// Arabic Language Pack
export default {
  // 检测部位
  part: {
    '车头': 'مقدمة السيارة',
    '发动机舱': 'حجرة المحرك',
    '左前车身': 'هيكل أمامي أيسر',
    '左前内饰': 'مقصورة داخلية أمامية يسرى',
    '左后车身': 'هيكل خلفي أيسر',
    '左后内饰': 'مقصورة داخلية خلفية يسرى',
    '车尾': 'مؤخرة السيارة',
    '后备箱内部': 'داخل صندوق الأمتعة',
    '右后车身': 'هيكل خلفي أيمن',
    '右后内饰': 'مقصورة داخلية خلفية يمنى',
    '右前车身': 'هيكل أمامي أيمن',
    '右前内饰': 'مقصورة داخلية أمامية يمنى',
    '机电': 'الميكانيكا والكهرباء',
    '新能源检测': 'فحص مركبات الطاقة الجديدة',
    '骨架': 'الهيكل الأساسي',
    '外观': 'الهيكل الخارجي',
    '内饰': 'المقصورة الداخلية',
    '其它': 'أخرى',
    '其他': 'أخرى',
    '水渍残留点': 'بقع ماء',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': 'ضرر بسيط',
    '严重损伤': 'ضرر شديد',
    '预检异常': 'شذوذ الفحص المسبق',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': 'لا يوجد ضرر ناتج عن حادث في العناصر الهيكلية والتعزيزية للمركبة.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'لا يوجد ضرر ناتج عن حادث في العناصر الهيكلية؛ توجد أضرار بسيطة ناتجة عن حادث في العناصر التعزيزية.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'لا يوجد ضرر ناتج عن حادث في العناصر الهيكلية؛ توجد أضرار شديدة ناتجة عن حادث في العناصر التعزيزية.',
    '车辆结构件有因事故造成的损伤': 'توجد أضرار ناتجة عن حادث في العناصر الهيكلية.',
    '外观极差': 'حالة خارجية سيئة للغاية',
    '内饰极差': 'حالة داخلية سيئة للغاية',
    '外观较差': 'حالة خارجية سيئة',
    '内饰较差': 'حالة داخلية سيئة',
    '外观一般': 'حالة خارجية متوسطة',
    '内饰一般': 'حالة داخلية متوسطة',
    '外观较好': 'حالة خارجية جيدة',
    '内饰较好': 'حالة داخلية جيدة',
    '外观准新': 'حالة خارجية شبه جديدة',
    '内饰准新': 'حالة داخلية شبه جديدة',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': 'المصباح الأمامي الأيسر',
    '左前雾灯': 'مصباح الضباب الأمامي الأيسر',
    '前底盘': 'قاع السيارة الأمامي',
    '前保险杠': 'المصد الأمامي',
    '中网': 'الشبكة الأمامية',
    '发动机舱盖外侧': 'الوجه الخارجي لغطاء المحرك',
    '发动机舱盖内侧': 'الوجه الداخلي لغطاء المحرك',
    '水箱框架': 'إطار الرادياتير',
    '前防撞梁': 'عارضة المصد الأمامي',
    '左前纵梁': 'العارضة الطولية الأمامية اليسرى',
    '左前翼子板骨架': 'الحاجز الداخلي للرفرف الأمامي الأيسر',
    '左前减震器支座': 'قاعدة ممتص الصدمات الأمامية اليسرى',
    '防火墙': 'جدار الحاجز',
    '车架号': 'رقم الشاسيه (VIN)',
    '右前减震器支座': 'قاعدة ممتص الصدمات الأمامية اليمنى',
    '右前翼子板骨架': 'الحاجز الداخلي للرفرف الأمامي الأيمن',
    '右前纵梁': 'العارضة الطولية الأمامية اليمنى',
    '发动机变速箱及附件': 'المحرك وناقل الحركة والملحقات',
    '机油': 'زيت المحرك',
    '防冻液': 'سائل التبريد',
    '刹车油': 'سائل الفرامل',
    '电池': 'البطارية',
    '皮带': 'السير',
    '保险丝盒': 'علبة الفيوزات',
    '发动机线束': 'مجموعة أسلاك المحرك',
    '左前轮胎': 'الإطار الأمامي الأيسر',
    '左前轮毂': 'الجنط الأمامي الأيسر',
    '左前避震器': 'ممتص الصدمات الأمامي الأيسر',
    '左前轮内衬罩': 'بطانة قوس العجلة الأمامية اليسرى',
    '左前翼子板': 'الرفرف الأمامي الأيسر',
    '左后视镜': 'المرآة الجانبية اليسرى',
    '前风挡玻璃': 'الزجاج الأمامي',
    '左A柱外侧': 'العمود A الأيسر من الخارج',
    '左前车顶': 'سقف أمامي أيسر',
    '左前门玻璃': 'زجاج الباب الأمامي الأيسر',
    '左前门外侧': 'اللوح الخارجي للباب الأمامي الأيسر',
    '左前门裙边外侧': 'العتبة الخارجية للباب الأمامي الأيسر',
    '左前门内侧': 'اللوح الداخلي للباب الأمامي الأيسر',
    '左前门内饰（含胶条）': 'كسوة الباب الأمامي الأيسر (تشمل الشرائط المانعة للتسرب)',
    '左A柱内侧': 'العمود A الأيسر من الداخل',
    '左前门裙边内侧': 'العتبة الداخلية للباب الأمامي الأيسر',
    '主驾座椅区域': 'منطقة مقعد السائق',
    '主驾座椅滑轨': 'سكة مقعد السائق',
    '主驾安全带': 'حزام أمان السائق',
    '左前地毯（含周边饰条、饰板）': 'السجاد الأمامي الأيسر (يشمل الزخارف والألواح المحيطة)',
    '转向管柱': 'عمود التوجيه',
    '方向盘': 'عجلة القيادة',
    '仪表盘': 'لوحة العدادات',
    '中控台': 'الكونسول الوسطي',
    '前排扶手区域': 'منطقة مسند الذراع الأمامي',
    '主驾仪表台': 'لوحة العدادات أمام السائق',
    '左A柱内饰板': 'كسوة العمود A الأيسر',
    '左前顶棚（含前排天窗饰板、遮阳板）': 'السقف الأمامي الأيسر (يشمل كسوة فتحة السقف وواقيات الشمس)',
    '前排天窗': 'فتحة السقف الأمامية',
    '内后视镜区域': 'منطقة المرآة الداخلية',
    '左后轮胎': 'الإطار الخلفي الأيسر',
    '左后轮毂': 'الجنط الخلفي الأيسر',
    '左后避震器': 'ممتص الصدمات الخلفي الأيسر',
    '左后轮内衬罩': 'بطانة قوس العجلة الخلفية اليسرى',
    '左后翼子板': 'الرفرف الخلفي الأيسر',
    '左C柱外侧': 'العمود C الأيسر من الخارج',
    '左后车顶': 'سقف خلفي أيسر',
    '左B柱外侧': 'العمود B الأيسر من الخارج',
    '左后门玻璃': 'زجاج الباب الخلفي الأيسر',
    '左后门外侧': 'اللوح الخارجي للباب الخلفي الأيسر',
    '左后门裙边外侧': 'العتبة الخارجية للباب الخلفي الأيسر',
    '左后门内侧': 'اللوح الداخلي للباب الخلفي الأيسر',
    '左后门内饰（含胶条）': 'كسوة الباب الخلفي الأيسر (تشمل الشرائط المانعة للتسرب)',
    '左C柱内侧': 'العمود C الأيسر من الداخل',
    '左B柱内侧': 'العمود B الأيسر من الداخل',
    '左后门裙边内侧': 'العتبة الداخلية للباب الخلفي الأيسر',
    '左后座椅区域': 'منطقة المقعد الخلفي الأيسر',
    '左后座椅滑轨': 'سكة المقعد الخلفي الأيسر',
    '左后安全带': 'حزام أمان المقعد الخلفي الأيسر',
    '左后地毯（含周边饰条、饰板）': 'السجاد الخلفي الأيسر (يشمل الزخارف والألواح المحيطة)',
    '后排扶手区域': 'منطقة مسند الذراع الخلفي',
    '左B柱内饰板': 'كسوة العمود B الأيسر',
    '左C柱内饰板': 'كسوة العمود C الأيسر',
    '左后顶棚（含后排天窗饰板）': 'السقف الخلفي الأيسر (يشمل كسوة فتحة السقف الخلفية)',
    '后排天窗': 'فتحة السقف الخلفية',
    '后风挡玻璃': 'الزجاج الخلفي',
    '左D柱外侧': 'العمود D الأيسر من الخارج',
    '右D柱外侧': 'العمود D الأيمن من الخارج',
    '后备箱盖外侧': 'الوجه الخارجي لغطاء صندوق الأمتعة',
    '左后尾灯': 'المصباح الخلفي الأيسر',
    '右后尾灯': 'المصباح الخلفي الأيمن',
    '后保险杠': 'المصد الخلفي',
    '后防撞梁': 'عارضة المصد الخلفي',
    '左后纵梁': 'العارضة الطولية الخلفية اليسرى',
    '右后纵梁': 'العارضة الطولية الخلفية اليمنى',
    '后底盘': 'قاع السيارة الخلفي',
    '后备箱盖内侧': 'الوجه الداخلي لغطاء صندوق الأمتعة',
    '后备箱盖内饰板（含胶条）': 'كسوة غطاء صندوق الأمتعة (تشمل الشرائط المانعة للتسرب)',
    '后部导水槽': 'قناة تصريف المياه الخلفية',
    '左D柱内饰板': 'كسوة العمود D الأيسر',
    '左D柱内侧': 'العمود D الأيسر من الداخل',
    '右D柱内饰板': 'كسوة العمود D الأيمن',
    '右D柱内侧': 'العمود D الأيمن من الداخل',
    '后窗台板': 'الرف الخلفي',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': 'كسوة صندوق الأمتعة (تشمل الشرائط المانعة للتسرب والسجاد والزخارف المحيطة)',
    '后围板': 'اللوح الخلفي للهيكل',
    '备胎轮胎': 'الإطار الاحتياطي',
    '备胎轮毂': 'الجنط الاحتياطي',
    '工具': 'الأدوات',
    '后备箱底板': 'أرضية صندوق الأمتعة',
    '左后翼子板骨架(包含减震器支座)': 'الحاجز الداخلي للرفرف الخلفي الأيسر (يشمل قاعدة ممتص الصدمات)',
    '右后翼子板骨架(包含减震器支座)': 'الحاجز الداخلي للرفرف الخلفي الأيمن (يشمل قاعدة ممتص الصدمات)',
    '右后轮胎': 'الإطار الخلفي الأيمن',
    '右后轮毂': 'الجنط الخلفي الأيمن',
    '右后避震器': 'ممتص الصدمات الخلفي الأيمن',
    '右后轮内衬罩': 'بطانة قوس العجلة الخلفية اليمنى',
    '右后翼子板': 'الرفرف الخلفي الأيمن',
    '右C柱外侧': 'العمود C الأيمن من الخارج',
    '右后车顶': 'سقف خلفي أيمن',
    '右B柱外侧': 'العمود B الأيمن من الخارج',
    '右后门玻璃': 'زجاج الباب الخلفي الأيمن',
    '右后门外侧': 'اللوح الخارجي للباب الخلفي الأيمن',
    '右后门裙边外侧': 'العتبة الخارجية للباب الخلفي الأيمن',
    '右后门内侧': 'اللوح الداخلي للباب الخلفي الأيمن',
    '右后门内饰（含胶条）': 'كسوة الباب الخلفي الأيمن (تشمل الشرائط المانعة للتسرب)',
    '右C柱内侧': 'العمود C الأيمن من الداخل',
    '右B柱内侧': 'العمود B الأيمن من الداخل',
    '右后门裙边内侧': 'العتبة الداخلية للباب الخلفي الأيمن',
    '右后座椅区域': 'منطقة المقعد الخلفي الأيمن',
    '右后座椅滑轨': 'سكة المقعد الخلفي الأيمن',
    '右后安全带': 'حزام أمان المقعد الخلفي الأيمن',
    '右后地毯（含周边饰条、饰板）': 'السجاد الخلفي الأيمن (يشمل الزخارف والألواح المحيطة)',
    '右B柱内饰板': 'كسوة العمود B الأيمن',
    '右C柱内饰板': 'كسوة العمود C الأيمن',
    '右后顶棚': 'السقف الخلفي الأيمن',
    '右A柱外侧': 'العمود A الأيمن من الخارج',
    '右前车顶': 'سقف أمامي أيمن',
    '右前门玻璃': 'زجاج الباب الأمامي الأيمن',
    '右前门外侧': 'اللوح الخارجي للباب الأمامي الأيمن',
    '右前门裙边外侧': 'العتبة الخارجية للباب الأمامي الأيمن',
    '右前门内侧': 'اللوح الداخلي للباب الأمامي الأيمن',
    '右前门内饰（含胶条）': 'كسوة الباب الأمامي الأيمن (تشمل الشرائط المانعة للتسرب)',
    '右A柱内侧': 'العمود A الأيمن من الداخل',
    '右前门裙边内侧': 'العتبة الداخلية للباب الأمامي الأيمن',
    '副驾座椅区域': 'منطقة مقعد الراكب',
    '副驾座椅滑轨': 'سكة مقعد الراكب',
    '副驾安全带': 'حزام أمان الراكب',
    '右前地毯（含周边饰条、饰板）': 'السجاد الأمامي الأيمن (يشمل الزخارف والألواح المحيطة)',
    '副驾仪表台': 'لوحة العدادات أمام الراكب',
    '右A柱内饰板': 'كسوة العمود A الأيمن',
    '杂物箱': 'صندوق القفازات',
    '右前顶棚（含前排天窗饰板、遮阳板）': 'السقف الأمامي الأيمن (يشمل كسوة فتحة السقف وواقيات الشمس)',
    '右前轮胎': 'الإطار الأمامي الأيمن',
    '右前轮毂': 'الجنط الأمامي الأيمن',
    '右前避震器': 'ممتص الصدمات الأمامي الأيمن',
    '右前轮内衬罩': 'بطانة قوس العجلة الأمامية اليمنى',
    '右前翼子板': 'الرفرف الأمامي الأيمن',
    '右后视镜': 'المرآة الجانبية اليمنى',
    '右前大灯': 'المصباح الأمامي الأيمن',
    '右前雾灯': 'مصباح الضباب الأمامي الأيمن',
    '启动': 'التشغيل',
    '变速箱': 'ناقل الحركة',
    '排烟': 'دخان العادم',
    '无钥匙进入': 'الدخول بدون مفتاح',
    '仪表盘功能自检': 'الفحص الذاتي للوحة العدادات',
    '转向助力': 'نظام التوجيه المعزز',
    '电动后视镜功能': 'وظيفة المرايا الكهربائية',
    '中控锁': 'القفل المركزي',
    '电动吸合门': 'الأبواب ذات الإغلاق الكهربائي الناعم',
    '电动座椅': 'المقاعد الكهربائية',
    '座椅记忆': 'ذاكرة المقعد',
    '座椅加热': 'تدفئة المقاعد',
    '座椅通风': 'تهوية المقاعد',
    '座椅按摩': 'تدليك المقاعد',
    '主驾驶电动门窗总控': 'التحكم الرئيسي بنوافذ السائق الكهربائية',
    '灯光系统': 'نظام الإضاءة',
    '前驻车雷达': 'حساسات الركن الأمامية',
    '后驻车雷达': 'حساسات الركن الخلفية',
    '倒车影像': 'كاميرا الرجوع للخلف',
    '全景摄像头': 'الكاميرا المحيطية',
    '可变悬架': 'التعليق التكيفي',
    '车载冰箱': 'الثلاجة الداخلية',
    '室内灯': 'إنارة المقصورة',
    '天窗': 'فتحة السقف',
    '雨刷': 'مساحات الزجاج',
    '多功能方向盘': 'عجلة قيادة متعددة الوظائف',
    '方向盘换挡拨片': 'مبدلات نقل الحركة على عجلة القيادة',
    '方向盘加热': 'عجلة قيادة مدفأة',
    '方向盘记忆': 'ذاكرة وضع عجلة القيادة',
    '空调': 'التكييف',
    '电动门': 'الأبواب الكهربائية',
    '电动车窗': 'النوافذ الكهربائية',
    '后排电动遮阳帘': 'الستارة الكهربائية الخلفية',
    '后排液晶屏': 'الشاشة الخلفية',
    '玻璃顶电动饰板': 'كسوة السقف الزجاجي الكهربائية',
    '硬顶敞篷': 'المكشوفة ذات السقف الصلب',
    '发动机': 'المحرك',
    '多媒体系统': 'نظام الوسائط المتعددة',
    '动力电池包安装点': 'نقاط تثبيت حزمة بطارية الطاقة',
    '动力电池包': 'حزمة بطارية الطاقة',
    '驱动电机(可见部分)': 'محرك الدفع (الجزء الظاهر)',
    '逆变器(可见部分)': 'العاكس (الجزء الظاهر)',
    '车身高压线束(可见部分)': 'مجموعة الأسلاك عالية الجهد للهيكل (الجزء الظاهر)',
    '随车充电枪': 'مسدس الشحن المتنقل',
    '车辆充电口': 'منفذ شحن المركبة',
    '增程器': 'موسع المدى',
    '动力系统故障码': 'رمز عطل مجموعة الدفع',
    '车辆充电故障': 'عطل شحن المركبة',
  },

  // 缺陷名称
  defect: {
    '安装不良': 'تركيب رديء',
    '常转': 'تشغيل مستمر',
    '超出上限': 'أعلى من الحد الأقصى',
    '闯档': 'تعشيق قاسٍ للتروس',
    '篡改': 'تلاعب',
    '打齿异响': 'صوت صرير التروس',
    '打滑': 'انزلاق',
    '打磨': 'صنفرة',
    '灯内异物': 'جسم غريب داخل المصباح',
    '低于下限': 'أدنى من الحد الأدنى',
    '断裂': 'كسر',
    '钣金修复': 'إصلاح الصفائح المعدنية',
    '改装': 'تعديل',
    '更换': 'استبدال',
    '功能失效': 'تعطل الوظيفة',
    '鼓包': 'انتفاخ',
    '故障': 'عطل',
    '后打胶': 'إعادة وضع المعجون خلفياً',
    '花屏': 'تشوه الشاشة',
    '划痕': 'خدش',
    '划伤': 'جروح سطحية',
    '晃动': 'ارتخاء / تأرجح',
    '变形': 'تشوه',
    '浑浊': 'عكارة السائل',
    '胶套损坏': 'تلف الغطاء المطاطي',
    '胶体异常': 'شذوذ المعجون',
    '胶条异常': 'شذوذ الشريط المانع للتسرب',
    '卡滞': 'انحباس',
    '空转': 'دوران حر',
    '老化': 'تقادم',
    '裂纹': 'تشقق',
    '冒白烟': 'دخان أبيض',
    '冒黑烟': 'دخان أسود',
    '不出风': 'لا يخرج هواء',
    '冒蓝烟': 'دخان أزرق',
    '霉斑': 'بقع العفن',
    '磨损': 'تآكل',
    '泥沙': 'طين ورواسب',
    '喷漆': 'إعادة دهان',
    '偏磨': 'تآكل غير متساوٍ',
    '破裂': 'تمزق',
    '破损': 'تلف',
    '启动困难': 'صعوبة التشغيل',
    '气囊爆裂': 'انفجار الوسادة الهوائية',
    '不跳档': 'لا ينقل التروس',
    '切割': 'قطع',
    '缺失': 'فقدان القطعة',
    '缺损': 'نقص',
    '缺线': 'فقدان الأسلاك',
    '入档困难': 'صعوبة تعشيق الترس',
    '色差': 'اختلاف اللون',
    '烧烫': 'احتراق',
    '渗水': 'تسرب مياه',
    '渗油': 'تسرب زيت',
    '失效': 'فقدان الفعالية',
    '不制冷': 'لا يبرد',
    '水雾': 'ضباب المياه',
    '松动': 'ارتخاء',
    '松旷': 'خلوص زائد',
    '损坏': 'تلف شديد',
    '损伤': 'ضرر',
    '塌陷': 'انخماد',
    '调节失效': 'فشل الضبط',
    '贴膜起泡': 'فقاعات العازل',
    '脱档': 'قفز الترس',
    '污渍': 'بقع',
    '不走车': 'المركبة لا تتحرك',
    '响应慢': 'استجابة بطيئة',
    '修复': 'إصلاح',
    '锈蚀': 'صدأ',
    '异味': 'رائحة',
    '异响': 'صوت غير طبيعي',
    '怠速不稳': 'خمول غير مستقر',
    '怠速过高': 'خمول مرتفع',
    '给不上油': 'انقطاع تزويد الوقود',
    '加速抖动': 'اهتزاز عند التسارع',
    '缺缸': 'عطل أسطوانة',
    '部件缺失': 'فقدان أجزاء',
    '气门异响': 'صوت الصمامات',
    '内部异响': 'صوت داخلي',
    '轮组异响': 'صوت مجموعة العجلة',
    '窜气': 'تسرب الغازات',
    '排气异响': 'صوت العادم',
    '水渍': 'بقع المياه',
    '凹陷': 'انبعاج',
    '车门更换': 'استبدال الباب',
    '拆卸': 'فك التركيب',
    '后盖更换': 'استبدال غطاء صندوق الأمتعة',
    '机盖更换': 'استبدال غطاء المحرك',
    '内饰更换': 'استبدال المقصورة الداخلية',
    '焊接': 'لحام',
    '开裂': 'تصدع',
    '剐蹭划伤': 'خدوش وجروح سطحية',
    '渗漏': 'تسرب',
    '火烧': 'حريق',
    '抖动': 'اهتزاز',
    '动力电池故障': 'عطل حزمة بطارية الطاقة',
    '驱动电机故障': 'عطل محرك الدفع',
    '其他': 'أخرى',
    '快充故障': 'عطل الشحن السريع',
    '慢充故障': 'عطل الشحن البطيء',
    '过火': 'آثار حريق',
    '缺气': 'ضغط هواء غير كافٍ',
  },

  // 等级
  grade: {
    'A': 'الفئة A',
    'B': 'الفئة B',
    'C': 'الفئة C',
    'D': 'الفئة D',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': 'لا توجد قطع خارجية مستبدلة',
    '外观原漆': 'الطلاء الأصلي',
    '外观无需整备成本': 'لا توجد تكلفة تجهيز للمظهر الخارجي',
    '内饰正常使用痕迹': 'علامات استخدام طبيعية في المقصورة',
    '车辆无骨架损伤': 'لا توجد أضرار هيكلية',
    '发动机工况无异常': 'حالة المحرك طبيعية',
    '变速器原地试车无异常': 'اختبار ناقل الحركة في مكانه طبيعي',
  },

  // 通用
  common: {
    '项': 'عناصر',
    '项异常': 'عناصر غير طبيعية',
    '分': 'نقاط',
    '级': 'الفئة',
    '检测': 'فحص',
    '图片': 'صورة',
    '加载失败': 'فشل التحميل',
    '加载中...': 'جار التحميل...',
  },

  // 页面标题
  title: {
    '车况检测': 'فحص حالة المركبة',
    '综合描述': 'الوصف العام',
    '综合': 'الإجمالي',
  },

  // 提示文案
  tips: {
    '源于出险数据': '(من بيانات الحوادث المؤمّنة)',
    '车辆是否曾进水(漏水/涉水/水泡)': 'هل تعرّضت المركبة سابقاً للماء (تسرب/خوض/غرق)؟',
    '是': 'نعم',
    '否': 'لا',
    '查看原图': 'عرض الصورة الأصلية',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': 'قواعد تقييم المظهر الخارجي',
    '骨架评级规则': 'قواعد تقييم الهيكل',
    '内饰评分规则': 'قواعد تقييم المقصورة الداخلية',
    '综合评级规则': 'قواعد التقييم الشامل',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': 'حالة خارجية شبه جديدة',
    '外观较好': 'حالة خارجية جيدة',
    '外观一般': 'حالة خارجية متوسطة',
    '外观较差': 'حالة خارجية سيئة',
    '外观极差': 'حالة خارجية سيئة للغاية',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': 'حالة داخلية شبه جديدة',
    '内饰较好': 'حالة داخلية جيدة',
    '内饰一般': 'حالة داخلية متوسطة',
    '内饰较差': 'حالة داخلية سيئة',
    '内饰极差': 'حالة داخلية سيئة للغاية',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': 'لا يوجد ضرر ناتج عن حادث في العناصر الهيكلية والتعزيزية للمركبة.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'لا يوجد ضرر ناتج عن حادث في العناصر الهيكلية؛ توجد أضرار بسيطة ناتجة عن حادث في العناصر التعزيزية.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'لا يوجد ضرر ناتج عن حادث في العناصر الهيكلية؛ توجد أضرار شديدة ناتجة عن حادث في العناصر التعزيزية.',
    '车辆结构件有因事故造成的损伤': 'توجد أضرار ناتجة عن حادث في العناصر الهيكلية.',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': 'الهيكل بدرجة ≥A، نقاط المظهر الخارجي ≥90، نقاط المقصورة الداخلية ≥90، لا يُسمح بالاستبدال أو القطع أو الصدأ أو الطين أو بقع المياه أو فقدان القطع أو العفن أو آثار الحرق أو تلف الوحدات الكهرو-ميكانيكية.',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': 'الهيكل بدرجة ≥A، نقاط المظهر الخارجي ≥80، نقاط المقصورة الداخلية ≥80، لا يُسمح بالقطع أو الطين أو بقع المياه أو العفن أو الصدأ أو ما شابه ذلك.',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': 'الهيكل بدرجة ≥B، نقاط المظهر الخارجي >40، نقاط المقصورة الداخلية >40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': 'الهيكل بدرجة ≥C، نقاط المظهر الخارجي ≥70، نقاط المقصورة الداخلية ≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': 'الهيكل بدرجة ≥D، نقاط المظهر الخارجي ≥60، نقاط المقصورة الداخلية ≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': 'الهيكل بدرجة ≥D، نقاط المظهر الخارجي ≥50، نقاط المقصورة الداخلية ≥40، لا يُسمح بتحديد مركبة غارقة.',
    '骨架等级≥D，外观评分<50，内饰评分<40': 'الهيكل بدرجة ≥D، نقاط المظهر الخارجي <50، نقاط المقصورة الداخلية <40',
  }
}
